<template>
  <v-card flat>
    <h1>{{ $t('application.instructor.instructor.title') }}</h1>

    <p>
      {{ $t('application.instructor.instructor.info') }}
      <i>{{ get(workplace, 'name', '') }}</i>
      {{ $t('application.instructor.instructor.info1') }}
    </p>

    <MessageBox class="mt-3">
      <h6>{{ $t('application.instructor.missing') }}</h6>
      <p>{{ $t('application.instructor.missing-info') }}</p>
      <ul><li><p>{{ $t('application.instructor.missing-info2') }}</p></li>
      <li><p>{{ $t('application.instructor.missing-info3') }}</p></li>
      <li><p>{{ $t('application.instructor.missing-info4') }}</p></li>
      <li><p>{{ $t('application.instructor.missing-info5') }}</p></li></ul>
      <p v-if="hasDepartments($route.params.id) == true" v-html="$t('application.instructor.missing-info6', {link1: loGet(links, 'application.departments', '#'), link2: loGet(links, 'main.bynRolesInfo', '#'), link3: loGet(links, 'main.bynInstructorInfo', '#')})">
      </p>            
    </MessageBox>

    <!-- Display instructors as a list -->
    <v-list class="box-shadow" flat v-if="showList && instructors && instructors.length > 0">
      <v-list-item-group v-model="model" :multiple="false" :mandatory="true">
        <v-radio-group v-model="model">

          <h6 class="mt-4 mb-0">{{ $t('application.instructor.gu-instructors') }}</h6>
          <template v-if="guInstructors.length">
            <template v-for="(item, index) in guInstructors">
              <v-list-item :key="`item-${index}`" @click="clickInstructor(item)">
                <v-list-item-content>
                  <v-list-item-title>{{ item.employed | fullName }}</v-list-item-title>
                  <v-list-item-subtitle v-if="loGet(item, 'apprentices')">
                    {{ $tc('labels.apprentice-count', item.apprentices.length) }}, <span class="text-lowercase">{{ getDescProf(item) }}</span>
                    </v-list-item-subtitle
                  >
                </v-list-item-content>
                <v-list-item-action>
                  <div class="v-list-item__radio">
                    <input type="radio" v-model="model" :value="index" />
                    <div class="check">
                      <div class="inside"></div>
                    </div>
                  </div>
                </v-list-item-action>
              </v-list-item>
              <v-divider :key="`divider-${index}`" v-if="index != instructors.length - 1"></v-divider>
            </template>
          </template>
          <template v-else>
            <MessageBox class="mt-3">
              <p>{{ $t('application.instructor.gu-instructors-missing') }}</p>
            </MessageBox>          
          </template>

          <h6 class="mt-4 mb-0">{{ $t('application.instructor.ktid-instructors') }}</h6>
          <template v-if="onlyKtidInstructors.length">
            <template v-for="(item, index) in onlyKtidInstructors">
              <v-list-item :key="`item-${index+guInstructors.length}`" @click="clickInstructor(item)">
                <v-list-item-content>
                  <v-list-item-title>{{ item.employed | fullName }}</v-list-item-title>
                  <v-list-item-subtitle v-if="loGet(item, 'apprentices')">
                    {{ $tc('labels.apprentice-count', item.apprentices.length) }}, <span class="text-lowercase">{{ getDescProf(item) }}</span>
                    </v-list-item-subtitle
                  >
                </v-list-item-content>
                <v-list-item-action>
                  <div class="v-list-item__radio">
                    <input type="radio" v-model="model" :value="index" />
                    <div class="check">
                      <div class="inside"></div>
                    </div>
                  </div>
                </v-list-item-action>
              </v-list-item>
              <v-divider :key="`divider-${index+guInstructors.length}`" v-if="index != instructors.length - 1"></v-divider>
            </template>
          </template>
          <template v-else>
            <MessageBox class="mt-3">
              <p>{{ "Det saknas tillgängliga handledare" }}</p>
            </MessageBox>          
          </template>

        </v-radio-group>
      </v-list-item-group>
    </v-list>
    <!-- Display erorr message if there is no instructor for the selected profession-->

    <v-expand-transition v-else>
      <MessageBox class="mt-3" type="info">
        <p v-html="$t('application.instructor.instructor.callByn')"></p>
      </MessageBox>
    </v-expand-transition>
    <v-expand-transition>
      <MessageBox class="mt-3" type="info" v-if="showErrorMsg">
        <p>{{ $t('application.instructor.instructor.missinginfo1') }}</p>
        <p>
          {{ $t('labels.read-more') }}
          <a href>{{ $t('application.instructor.instructor.rules') }}</a>
        </p>
      </MessageBox>
    </v-expand-transition>

    <!-- Go to a next step-->
    <NextButton
      v-if="isCompanyUser(this.$route.params.id)"
      :isDisabled="model == null || model < 0"
      class="mt-6"
      @click="nextStep"
      >{{ $t('btn.employment-next-step') }}</NextButton
    >
    <!-- Go to a previous  step-->
    <BottomNav @clicked="clickBack" />
  </v-card>
</template>

<script>
import API from '@/services/api.js'
import {mapActions, mapGetters} from 'vuex'
import {CompanyRoles, InstructorAbilities} from '@/components/mixins'
import pick from 'lodash/pick'
import find from 'lodash/find'
import get from 'lodash/get'
import BottomNav from '@/components/Application/BottomNav'
import NextButton from '@/components/Common/NextButton'
import MessageBox from '@/components/Common/MessageBox'
// @group Application-Company
// ApplicationInstructor component
export default {
  name: 'ApplicationInstructor',

  mixins: [CompanyRoles, InstructorAbilities],

  components: {
    BottomNav,
    NextButton,
    MessageBox
  },

  data() {
    return {
      links: require('../../../lib/external-links.json'),
      instructors: [],
      guInstructors: [],
      onlyKtidInstructors: [],
      professions: [],
      professionObj: [],
      search: '',
      model: null,
      application: null,
      fields: ['id', 'instructorId', 'step'],
      instructorInfo: '',
      showAddNew: true,
      showErrorMsg: false,
      showList: false,
      workplace: {},
      tradeCertificates: []
    }
  },

  created() {
    if (!this.currentUser) return
    this.initApplication()
    this.fetchinstructors()
  },
  
  computed: {
    ...mapGetters('currentuser', ['currentUser', 'isApprentice', 'isCompanyUser']),
    ...mapGetters('application', ['currentStep', 'selectedApplication']),
    ...mapGetters('basic', ['basicProfessions', 'getProfessionById'])
  },
  methods: {
    get,
    
    ...mapActions('application', ['updateSelectedApplication']),
    /**
     * @vuese
     * Used to Initialize application with either selected instructorId or select a new one
     */
    initApplication() {
      if (this.selectedApplication && this.selectedApplication.id) {
        this.application = pick(this.selectedApplication, this.fields)
      } else {
        this.application = Object.fromEntries(
          this.fields.map(f => {
            return [f, null]
          })
        )
      }

      this.application.step = this.currentStep
    },
    /**
     * @vuese
     * Used to fetch instructors that have a certificate for a specific profession and no more than 3 apprenticenships
     * @arg The argument is an integer value representing company id
     */
    fetchinstructors() {
      if (get(this, 'selectedApplication.id') > 0 && get(this, 'selectedApplication.companyId') > 0) {
        API.listEmployments(this.selectedApplication.companyId, {type: 'instructor'})
          .then(res => { 
            if (res.data) {
              //- Instructors must have tradecertificate for chosen profession and not more than allowed apprentices already
              const pi = get(this, 'professionObj.id', -1)

              const orientations = get(this, 'selectedApplication.professionOrientations', []).map(o => get(o, 'professionMachineOrientation.machineId', -1))
              this.guInstructors = res.data.filter(i => this.canHaveAnotherApprentice(i, pi, orientations, true))
              const ktidInstructors = res.data.filter(i => this.canHaveAnotherApprentice(i, pi, orientations, false))
              this.onlyKtidInstructors = ktidInstructors.filter(i => !find(this.guInstructors, ['id', i.id]))

              this.instructors = res.data.filter(i => this.canHaveAnotherApprentice(i, pi, orientations, false))

              if (this.hasDepartments(this.$route.params.id) == true) {
                if(this.selectedApplication.departmentId && this.selectedApplication.departmentId>0)
                {
                  this.guInstructors = res.data.filter(i => this.hasDepartmentIdForRole(i, this.selectedApplication.departmentId, 'isDepartmentInstructor'))
                }
              }

              // Select previously selected instructor 
              if (get(this, 'selectedApplication.instructorId', 0) > 0) {
                this.model = this.instructors.findIndex(x => x.id === this.selectedApplication.instructorId)
                this.application.instructorId = this.selectedApplication.instructorId
              } else if (get(this, 'instructors.length', 0) > 0) {
                this.model = 0
                
                const instructors = get(this, 'guInstructors', []).length ? 
                  this.guInstructors : 
                  this.instructors

                this.application.instructorId = instructors[0].id
              }

              this.showErrorMsg = false
              this.showList = true
            } else {
              this.showErrorMsg = true
              this.showList = false
            }

          })
          .catch(err => {
            console.log(err)
          })
          .finally(() => (this.isLoading = false))
      }
      this.getProfessions()
      this.fetchworkplaces()
    },

    getDescProf(emp) {
      let ret = [];

      const exemptions = get(emp, 'employed.instructorExemptions', []).map (e => get(e, 'profession.name', null))
      if (exemptions.length) {
        ret.push(exemptions)
      }

      const tradeCertificates = get(emp, 'employed.tradeCertificates', []).map (e => get(e, 'profession.name', null))
      if (tradeCertificates.length) {
        ret.push(tradeCertificates)
      }

      return ret.join(", ");
    },
    /**
     * @vuese
     * Used to fetch professions and get the selected profession if there is any
     */
    getProfessions() {
      this.professions = this.basicProfessions.map((o) => {
        if(o.id && o.name && o.maxApprenticesForInstructor){
          return { id: o.id, text: o.name, maxApp: o.maxApprenticesForInstructor };
        }
      });
      let prof = this.professions.find(
        (x) => x.id == get(this, 'selectedApplication.professionId', null)
      );
      if (prof) {
        this.professionObj = prof
      }
    },
    /**
     * @vuese
     * Used to fetch workplaces
     * @arg The arguments are integers values representing company id and workplace id
     */
    fetchworkplaces() {
      if (get(this, 'selectedApplication.id') > 0 && get(this, 'selectedApplication.companyId') > 0) {
        API.getCompanyWorkspaces(this.selectedApplication.companyId)
          .then(res => {
            let wrp = find(res.data, {
              id: this.selectedApplication.workplaceId
            })
            if (wrp) {
              this.workplace = wrp
            }
          })
          .catch(err => {
            console.log(err)
          })
          .finally(() => (this.isLoading = false))
      }
    },
    /**
     * @vuese
     * Used to got to a previous step
     */
    clickBack() {
      this.model = this.instructors.findIndex(x => x.id === this.selectedApplication.instructorId)
      // Fire +1
      // @arg The argument is a integer representing (in which step to go)
      if (this.hasDepartments(this.$route.params.id) == true) {
        this.$emit('goToStep', '-1')
      } else {
        this.$emit('goToStep', '-2')
      }
    },

    /**
     * @vuese
     * Used to set Instructor id based on which Instructor user has selected
     */
    clickInstructor(item) {
      this.application.instructorId = item.id
    },

    /**
     * @vuese
     * Used to go to the next step if form is valid and update the application with new or selected instructor
     * @arg The argument is an integer value application  id and params are the selected fields
     */
    async nextStep() {
      if (this.application && this.application.instructorId && this.application.instructorId > 0) {
        this.selectedApplication.instructorId = this.application.instructorId
        this.selectedApplication.step = this.currentStep

        API.updateApplication(this.application.id, {
          data: this.application
        })
          .then(() => {
            /**
             * @vuese
             * Used to update application in vuex store with instructor  selected
             */
            this.updateSelectedApplication(this.application)

            // Fire +1
            // @arg The argument is a integer representing (in which step to go)

            this.$emit('goToStep', '+1')
          })
          .catch(error => {
            this.$events.fire('showError', this.$t('errors.form-validation'))
            console.log('There was an error:', error)
          })
      }
    }
  }
}
</script>

<style scoped lang="scss">
/* The Modal (background) */
.modal {
  display: none; /* Hidden by default */
  position: fixed; /* Stay in place */
  z-index: 1; /* Sit on top */
  padding-top: 100px; /* Location of the box */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.4);
}

/* Modal Content */
.modal-content {
  background-color: #fefefe;
  margin: auto;
  padding: 25px;
  border: 1px solid #888;
  max-width: 400px;
  max-height: 150vh;
}

/* The Close Button */
.close {
  color: #aaaaaa;
  float: right;
  font-size: 28px;
}

.close:hover,
.close:focus {
  color: #000;
  text-decoration: none;
  cursor: pointer;
}
.move-right {
  text-align: end;
}
@media only screen and (max-width: 960px) {
  .modal-content {
    top: 34px;
    right: -2vw;
    width: 90vw;
    height: 80vh;
  }
}
</style>
